import {useRouter} from "vue-router/composables";
import {useAlert} from "@/composables/useAlert";
import {ACCESS_TOKEN_KEY} from "@/constants/localStorageKeys";
import Mypage from "@/api/v1/mypage";

export const useNavigateByWorkerStatus = (isLoading) => {
  const router = useRouter()
  const { showErrorAlert } = useAlert()

  const navigate = () => {
    if (localStorage.getItem(ACCESS_TOKEN_KEY)) {
      isLoading.value = true;

      Mypage.get({})
        .then((response) => {
          if (response.status === 200) {
            const payload = response.data.payload;


            if (payload.recruit_status === 3) {
              // 審査中
              router.replace({ name: 'registrationCompleted' });
            } else if (payload.recruit_status <= 7) {
              // 審査通過済み
              router.replace({ name: 'completed' });
            }

            if (payload.member_status === -3) {
              // 審査落ち
              router.replace({ name: 'reviewFailed' });
            } else if (payload.member_status === -1) {
              // 凍結済み
              router.replace({ name: 'suspended' });
            }
          }
        })
        .catch(showErrorAlert)
        .finally(() => {
          isLoading.value = false
        });
    }
  }

  return { navigate }
}
